import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { resource } from "@util/resource";
import { DWS } from "@interfaces/dws";
import { WineryInfo } from "@interfaces/dws/winery-info";

@Injectable({
  providedIn: "root",
})
export class WineryClosingService {
  constructor() {}
  getWineryClosingsWithFilter(
    wineryId: string,
    startDate: string,
    endDate: string
  ): Observable<WineryInfo.ClosingPeriod[]> {
    return resource("crm://v2/closing-days/wineryId/filter")
      .params({ wineryId  })
      .post({startDate, endDate});
  }

  getWineryClosings(wineryId: string): Observable<WineryInfo.ClosingPeriod[]> {
    return resource("crm://v2/closing-days/wineryId")
      .params({ wineryId })
      .get();
  }
}
